import { useEffect, useState } from 'react'
import { Plug, PlugZap } from 'lucide-react'
import { apiClient } from '@/lib/api/client'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

export function McpStatus() {
  const [isConnected, setIsConnected] = useState<boolean>(false)
  const [serverCount, setServerCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const checkMcpStatus = async () => {
      try {
        const response = await apiClient.get('/mcp-servers')
        const data = response.data

        // Response has { servers: [...] } structure
        const servers = data.servers || []

        // Count active servers
        const activeServers = servers.filter((s: { is_active: boolean }) => s.is_active)
        setServerCount(activeServers.length)
        setIsConnected(activeServers.length > 0)
      } catch {
        setIsConnected(false)
        setServerCount(0)
      } finally {
        setIsLoading(false)
      }
    }

    checkMcpStatus()
    // Recheck every 30 seconds
    const interval = setInterval(checkMcpStatus, 30000)

    return () => clearInterval(interval)
  }, [])

  if (isLoading) {
    return null
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className="flex items-center gap-1.5 text-[11px] cursor-help">
          {isConnected ? (
            <>
              <PlugZap className="w-3 h-3 text-green-600 dark:text-green-400" />
              <span className="text-muted-foreground">
                MCP:{' '}
                <span className="font-medium text-green-600 dark:text-green-400">
                  {serverCount}
                </span>
              </span>
            </>
          ) : (
            <>
              <Plug className="w-3 h-3 text-muted-foreground/50" />
              <span className="text-muted-foreground/70">MCP: Off</span>
            </>
          )}
        </div>
      </TooltipTrigger>
      <TooltipContent side="bottom" className="max-w-xs">
        <p className="font-medium mb-1">Model Context Protocol (MCP)</p>
        {isConnected ? (
          <p className="text-xs opacity-90">
            {serverCount} MCP server{serverCount > 1 ? 's' : ''} connected. Your AI assistant can
            access EcoSemantic's LCA tools through these connections.
          </p>
        ) : (
          <p className="text-xs opacity-90">
            No external MCP connections. Use this playground to test tools, or connect Claude,
            ChatGPT, or other AI clients via the Connections tab.
          </p>
        )}
      </TooltipContent>
    </Tooltip>
  )
}
